<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>①　Webブラウザを起動します。</p>
                    <p>※ サポート対象ブラウザ：Google Chrome、Microsoft Edge、Safari、Firefox</p>
                </div>
                <div><img src="/static\images\ja\newManual\logo_browse_1.png" alt="" /></div>
                <div>
                    <p>②　下記のURLにアクセスしてください。</p>
                    <p><a href="https://study.adsol-asia.jp">https://study.adsol-asia.jp</a></p>
                </div>
                <div><img src="/static\images\ja\newManual\url_dongdu.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>①　Webブラウザを起動します。</p>
                    <p>※ サポート対象ブラウザ：Google Chrome、Microsoft Edge、Safari、Firefox</p>
                </div>
                <div><img src="/static\images\ja\newManual\logo_browse_1.png" alt="" /></div>
                <div>
                    <p>②　下記のURLにアクセスしてください。</p>
                    <p><a href="https://study.adsol-asia.jp">https://study.adsol-asia.jp</a></p>
                </div>
                <div><img src="/static\images\ja\newManual\url_dongdu.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/usingPc_manual.vue